import styled, { css } from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.footer`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 5rem;
  margin-top: 3rem;

  ${({ theme }) => css`
    background: ${theme.colors.surface};
    .made-with-love,
    .copyright,
    .privacy-terms {
      font-size: ${theme.font.sizes.xsmall};
      color: ${theme.colors.highContrast};
      margin-top: 0.5rem;
    }

    .copyright {
      font-size: 1rem;
      text-align: center;
      margin-top: 2rem;
    }

    a:link {
      color: ${theme.colors.highContrast};
    }

    .information {
      font-size: ${theme.font.sizes.xsmall};
      line-height: 1.5;
      color: ${theme.colors.highContrast};
      margin-bottom: 1rem;
    }

    .contacts {
      margin-top: 0.5rem;
      font-size: ${theme.font.sizes.small};

      svg {
        margin-right: 0.5rem;
      }

      a:link {
        color: ${theme.colors.black};
      }
    }

    ul {
      margin-top: 0.5rem;
      list-style-type: none;
      li {
        color: ${theme.colors.highContrast};
        font-size: ${theme.font.sizes.small};
        margin-top: 0.5rem;

        span {
          margin-right: 1rem;
        }
      }
    }

    .centralized-container {
      ${media.lessThan('medium')`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      `}
    }
  `}

  ${media.lessThan('large')`
    flex-direction: column;
    padding: 3.2rem 7rem;

    gap: 3rem;
  `}

  ${media.lessThan('small')`
    padding: 3.2rem 1rem;
  `}
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 2rem 0;

  border: 0.5px solid ${({ theme }) => theme.colors.border};
`;

export const ContainerTitle = styled.div`
  label {
    font-weight: 700;
    font-size: 1.6rem;
    color: ${({ theme }) => theme.colors.dark};
  }
`;
